@import '../../sass/helpers';

:host {
  /**
  * @prop --padding-top: This style control the top padding of content container.
  */
  --padding-top: 1rem;
  /**
  * @prop --padding-bottom: This style control the bottom padding of content container.
  */
  --padding-bottom: 1rem;
  /**
  * @prop --padding-right: This style control the right padding of content container.
  */
  --padding-right: 1rem;
  /**
  * @prop --padding-left: This style control the left padding of content container.
  */
  --padding-left: 1rem;
}

.content {
  display: block;
  padding: var(--padding-top) var(--padding-right) var(--padding-bottom) var(--padding-left);
}

@each $breakpoint in map-keys($grid-breakpoints) {
  @include media-breakpoint-up($breakpoint) {
    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);

    @each $prop, $abbrev in (margin: m, padding: p) {
      @each $size, $length in $spacers {
        .#{$abbrev}#{$infix}-#{$size} { #{$prop}: $length !important; }
        .#{$abbrev}t#{$infix}-#{$size},
        .#{$abbrev}y#{$infix}-#{$size} {
          #{$prop}-top: $length !important;
        }
        .#{$abbrev}r#{$infix}-#{$size},
        .#{$abbrev}x#{$infix}-#{$size} {
          #{$prop}-right: $length !important;
        }
        .#{$abbrev}b#{$infix}-#{$size},
        .#{$abbrev}y#{$infix}-#{$size} {
          #{$prop}-bottom: $length !important;
        }
        .#{$abbrev}l#{$infix}-#{$size},
        .#{$abbrev}x#{$infix}-#{$size} {
          #{$prop}-left: $length !important;
        }
      }
    }
  }
}